import React, { useState } from "react";
import { ChevronDown, ChevronRight } from "lucide-react";
import { fmtPct } from "../labels";

export function Block({ id, title, subtitle, children, defaultOpen = true }) {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <section className="border border-clay-300 bg-white" data-testid={`kk-block-${id}`}>
      <button onClick={() => setOpen(!open)} className="w-full text-left px-5 py-3 flex items-center gap-2 hover:bg-clay-50" data-testid={`kk-block-${id}-toggle`}>
        {open ? <ChevronDown size={14}/> : <ChevronRight size={14}/>}
        <span className="font-serif text-xl">{title}</span>
        {subtitle && <span className="text-[11px] text-clay-500 ml-auto hidden md:inline">{subtitle}</span>}
      </button>
      {open && <div className="border-t border-clay-200 px-5 py-4 space-y-5">{children}</div>}
    </section>
  );
}

export function Sub({ title, hint, children }) {
  return (
    <div>
      <div className="flex flex-wrap items-baseline gap-x-2 gap-y-0.5 mb-2"><span className="smallcaps">{title}</span>{hint && <span className="text-[11px] text-clay-500">{hint}</span>}</div>
      {children}
    </div>
  );
}

// thin proportion bar
export function Bar({ value, max, tone = "bg-terracotta" }) {
  const w = max ? Math.max(2, Math.round(100 * (value || 0) / max)) : 0;
  return <span className="inline-block h-1.5 w-24 bg-clay-100 align-middle"><span className={`block h-1.5 ${tone}`} style={{ width: `${w}%` }}/></span>;
}

export const convTone = (v) => (v == null ? "text-clay-500" : v >= 10 ? "text-emerald-800" : v >= 5 ? "text-amber-800" : "text-terracotta");

// clickable number → leads list filtered
export function N({ value, onClick, tone, testid, title }) {
  if (value == null) return <span className="text-clay-400">—</span>;
  if (!onClick || value === 0) return <span className={`tabular ${tone || ""}`}>{value}</span>;
  return <button onClick={onClick} title={title || "Ver los leads"} data-testid={testid} className={`tabular underline decoration-dotted underline-offset-2 hover:text-terracotta ${tone || ""}`}>{value}</button>;
}

export function Conv({ value }) {
  return <span className={`tabular font-semibold ${convTone(value)}`}>{fmtPct(value)}</span>;
}

export const th = "px-2 py-1.5 text-left font-medium text-clay-600 text-[11px] whitespace-nowrap";
export const td = "px-2 py-1.5 tabular whitespace-nowrap";
export const tdr = "px-2 py-1.5 tabular text-right whitespace-nowrap";
export const thr = "px-2 py-1.5 text-right font-medium text-clay-600 text-[11px] whitespace-nowrap";
